import { cn } from '@zoomit/primitives';
import type { KeySpecification } from '@zoomit/web-kit';
import { IconRenderer, isMobile } from '@zoomit/web-kit';
import { cssVar, theme } from '@zoomit/zoomit-ds';

type Props = {
  data: KeySpecification[] | undefined;
} & React.HTMLAttributes<HTMLDivElement>;

const KeySpecs = (props: Props) => {
  const { data, className, ...rest } = props;

  return (
    <div
      {...rest}
      className={cn(
        'grid w-full grow grid-cols-2 grid-rows-1 gap-2 sm:grid-cols-3 lg:w-auto xl:grid-cols-4',
        className,
      )}
    >
      {data?.map((keySpec) => <KeySpecItem key={keySpec.id} data={keySpec} />)}
    </div>
  );
};

type KeySpecItemProps = { data: KeySpecification; className?: string };
const KeySpecItem = (props: KeySpecItemProps) => {
  const {
    data: { primaryValue, secondaryValue, desktopIcon, mobileIcon },
    className,
  } = props;

  return (
    <div
      className={cn(
        'bg-background1 relative flex w-full items-center gap-3 rounded-md p-3 sm:bg-transparent sm:p-0 [&:nth-child(n+4)]:sm:hidden [&:nth-child(n+4)]:xl:flex',
        className,
      )}
    >
      {isMobile
        ? mobileIcon && (
            <IconRenderer
              className="absolute top-3 left-3 sm:static"
              icon={mobileIcon.content}
              size="md"
              fill={cssVar(theme.grey1)}
            />
          )
        : desktopIcon && <IconRenderer icon={desktopIcon.content} size="xxl" fill={cssVar(theme.grey1)} />}

      <div className="text-subhead flex flex-col justify-center gap-2 overflow-hidden px-0.5">
        <div className="text-body overflow-hidden text-nowrap text-ellipsis">{primaryValue}</div>
        <div className="text-grey1 text-callout overflow-hidden text-nowrap text-ellipsis">
          {secondaryValue}
        </div>
      </div>
    </div>
  );
};

export default KeySpecs;
